module.exports = __webpack_public_path__ + "static/media/logoPsurvey.5172f2b6.png";